import { IUpdateEventoUseCase } from "../../../presentation/useCases/update/update_evento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateEventoUseCase
 */

export class UpdateEventoUseCase implements IUpdateEventoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async updateEvento(
    idItemVerbaFuncionario: number,
    idItemVerba: number,
    valor: number,
    descricao: string | null,
  ): Promise<void> {
    await this.repository.updateEvento(
      idItemVerbaFuncionario,
      idItemVerba,
      valor,
      descricao,
    );
  }
}